<template>
  <section
    class="w-full bg-white p-5 mb-4 flex flex-col"
  >
    <span class="course-title text-lg font-bold text-h-neutral-900 mb-2">
      {{
        $t("labels.generic", {
          pt: "Andamento do curso",
          en: "Progress course",
        })
      }}
    </span>

    <span class="text-xs text-h-neutral-700">
      {{
        $t("labels.generic", {
          pt: "Progresso",
          en: "Progress",
        })
      }}
    </span>

    <div class="flex flex-row items-center">
      <ProgressBar
        class="progressbar-style w-full"
        style="height: 8px"
        :value="storeChapter.percentages.coursePercentage"
        :show-value="false"
      />
      <span class="text-sm font-bold ml-1"
        >{{ storeChapter.percentages.coursePercentage }}%</span
      >
    </div>
  </section>
</template>

<script lang="ts">
import { useChapterStore } from "@/store/linear/chapter";
import { defineComponent } from "vue";

export default defineComponent({
  name: "percentageCard",
  setup() {
    const storeChapter = useChapterStore;

    return { storeChapter };
  },
});
</script>
